import store from '../../store';

export default async (to, from, next) => {
  const productIds = (to.query.productIds || '').split(',');
  if (productIds.length > 1) {
    store.dispatch('compare/getProducts', productIds);
    store.dispatch('compare/getOptions');
    store.dispatch('compare/getProperties');
    store.dispatch('finishLoading');
    next();
  } else {
    store.commit('compare/SET_PRODUCTS', []);
    store.dispatch('finishLoading');
    next({ name: 'home' });
  }
};
